export default __webpack_public_path__ + "static/clean-ingredients_experts_Dr-Matt-Leaderman-d67c8ce03e73e027ee6c3ba3442ca4f2.png";